import axios from "axios";
import { BASE_URL } from "../constants";
import getHeaders from "../constants/headers";

export const getUserProfile = () => {
  return axios({
    method: "get",
    url: BASE_URL + "api/v2/user-profile",
    headers: getHeaders(),
  });
};
